{
  "appName": "AirPlx",
  "logoAlt": "AirPlx Logo",
  "errors": {
    "authRequired": "User authentication required",
    "loginAgain": "Please log in again to accept invitations",
    "serviceUnavailable": "Service unavailable",
    "serviceTemporarilyUnavailable": "Service temporarily unavailable. Please try again.",
    "emailRequired": "Email required",
    "emailRequiredValidation": "User email is required to validate invitation",
    "inviteInvalid": "Invite is no longer valid or has already been claimed",
    "invalidFBOInfo": "Invalid FBO information in invitation",
    "inviteCouldNotBeClaimed": "Invite could not be claimed",
    "acceptFailed": "Failed to accept invitation"
  },
  "inviteStatus": {
    "pending": "Pending",
    "accepting": "Accepting...",
    "tryAgain": "Try Again",
    "accept": "Accept"
  }
}
